import { React, useState, useEffect, useRef } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { makeStyles } from "@mui/styles";

import PropTypes from "prop-types";
import AvatarGroup from "../LikeComment/AvatarGroup";
import LikeComment from "../LikeComment/LikeComment";
import Comment from "../LikeComment/Comment";
import noprofile from "../../common/images-new/no-profile-pic.png";

import { serverUrl, apiUrl } from "../../components/Helpers/Config";
import moment from "moment";
import CommentInput from "../LikeComment/CommentInput";
import {
  htmlToText,
  trimString,
  getProfilePic,
  convertDate,
  convertDateFormat,
  removeIframe,
  tokenAuthorize,
} from "../../components/Helpers/Common";
import { getShowcases, deleteShowcasePost } from "../../redux/actions/showcase";
import { staticFiles } from "../Helpers/Static";
import {
  BgComment,
  BgWhite,
  ButtonCommonTop,
  Card,
  TextGray,
  MenuItemCard,
  MenuItemDiv,
  ButtonCommonTopNew,
  CardNew,
} from "../../pages/Theme";
import Swal from "sweetalert2";
import ButtonCommon from "../Button/ButtonCommon";
import { Loading } from "../../components/Helpers/Common";
import MoreOptionsDropdown from "../../pages/Profile/MoreOptionsDropdown";
import Tooltip from "@mui/material/Tooltip";
import { IoMdLock } from "react-icons/io";
import { MdOutlinePublic } from "react-icons/md";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import SortingIcon from "../../common/images-new/sorting-icon.svg";
import SendIcon from "@mui/icons-material/Send";
import { LuSend } from "react-icons/lu";
import ChatInput from "../LikeComment/ChatInput";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { BsSortUpAlt } from "react-icons/bs";
import { BsSortDownAlt } from "react-icons/bs";
import { BsSortUp } from "react-icons/bs";
import { BsSortDown } from "react-icons/bs";
import SortToggle from "../../components/Button/SortToggle";
import RichTextReadMore from "../../components/Editor/RichTextReadMore";
import { FaRegCommentDots } from "react-icons/fa";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { CommonLoader } from "../Button/Loader";
const NO_IMAGE = staticFiles.noImage;
const MORE_GRAY = staticFiles.more;

const CardPost = ({ post, profile, tabId, isView }) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const userProfile = useSelector((state) => state.auth.user);
  const [comment, setComment] = useState("");
  const [commentList, setCommentList] = useState([]);
  // const [commentLatest, setCommentLatest] = useState([]);
  const [numComments, setnumComments] = useState(0);
  const popupRef = useRef();
  const [currentIsLiked, setCurrentIsLiked] = useState(0);
  const [loadingComments, setLoadingComments] = useState(false);
  const [offsetComments, setOffsetComments] = useState(0);
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const userTheme = useSelector((state) => state.auth.theme);
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const useStyles = makeStyles((theme) => ({
    customMenu: {
      backgroundColor:
        isDefaultTheme == false && userTheme
          ? `${userTheme?.color3} !important`
          : "white !important",
      width: "200px !important;",
    },
  }));
  const classes = useStyles();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    if (post?.liked) {
      setCurrentIsLiked(post.liked);
    } else {
      setCurrentIsLiked(0);
    }
  }, [post]);

  const [toggleComment, setToggleComment] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const [sortOrder, setsortOrder] = useState("desc");
  const [sortOrderInitial, setsortOrderInitial] = useState("desc");

  const divRef = useRef(null);

  useEffect(() => {
    let str = sortOrder;
    if (localStorage.getItem("sortOrder") != undefined) {
      str = localStorage.getItem("sortOrder");
    }
    // getComments(str, offsetComments)
    setsortOrder(str);
    setsortOrderInitial(str);
  }, [post.id]);

  const handleCommentClick = () => {
    setToggleComment(!toggleComment);
    let str = sortOrder;
    if (localStorage.getItem("sortOrder") != undefined) {
      str = localStorage.getItem("sortOrder");
      setsortOrder(str);
    }
    if (!toggleComment === false) {
      dispatch(getShowcases());
      setOffsetComments(0);
      setHasMoreComments(false);
      setsortOrderInitial(str);
      setCommentList([]);
    }
    if (!toggleComment === true) {
      setLoadingComments(true);
      getComments(offsetComments);
    }
    // if (!toggleComment === false) {
    //     setsortOrder("desc")
    // }
    // if (hasMoreComments == true) {
    //     getComments(str, offsetComments)
    // }
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setDropdown(!dropdown);
  };

  const likePost = (isLiked) => {
    return axios
      .post(serverUrl.ReflectionPost + "/like", {
        reflection_id: post.id,
        like: isLiked,
      })
      .then((resp) => {
        if (resp.status === 200) {
          changeLike();
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const changeLike = () => {
    return axios.get(apiUrl + "reflection/" + post.id).then((res) => {
      if (res.status === 200) {
        dispatch(getShowcases());
        let like = res.data.post.like;
        setCurrentIsLiked(parseInt(like));
      }
    });
  };

  const getComments = (offset) => {
    return axios
      .get(
        apiUrl +
          "comments/" +
          post.id +
          "?sort_order=" +
          sortOrderInitial +
          "&limit=10&offset=" +
          offset
      )
      .then((resp) => {
        if (resp.status === 200) {
          let data = [];
          data = resp.data.results;
          // const newCommentList = resp.data.results;
          // dispatch(getShowcases())
          if (resp.data.results?.length > 9) {
            setHasMoreComments(true);
          } else {
            setHasMoreComments(false);
          }
          // if (offset != 0) {
          //     // if (sortOrder == "asc") {
          //     //     setCommentList([
          //     //         ...commentList,
          //     //         ...newCommentList
          //     //     ])
          //     // }
          //     // if (sortOrder == "desc") {
          //     if (hasMoreComments == false || load == true) {
          data = [...data, ...commentList];
          // setCommentList([
          //     ...commentList,
          //     ...newCommentList
          // ]);
          //     }
          //     // }
          // } else {
          //     setCommentList(newCommentList);
          // }
          // setCommentList(newCommentList)
          // setnumComments(newCommentList.length);
          // if (newCommentList?.length > 0) {
          //     if (str == "desc") {
          //         setCommentLatest([newCommentList[0]])
          //     }
          //     if (str == "asc") {
          //         setCommentLatest([newCommentList[newCommentList?.length - 1]])
          //     }
          // } else {
          //     setCommentLatest([])
          // }
          if (sortOrder == "asc") {
            const ascSortedData = data
              ?.slice()
              .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
            setCommentList(ascSortedData);
          }
          if (sortOrder == "desc") {
            const descSortedData = data
              ?.slice()
              .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
            setCommentList(descSortedData);
          }
          setLoadingComments(false);
        } else {
          setLoadingComments(false);
        }
      })
      .catch((err) => {
        setLoadingComments(false);
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const deleteComment = (commentId) => {
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure you want to delete this comment?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(serverUrl.Comment2 + "/" + commentId)
          .then((resp) => {
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Comment has been deleted",
              icon: "success",
            });
            if (resp.status === 200) {
              post.comments = post.comments - 1;
              let str = sortOrder;
              if (localStorage.getItem("sortOrder") != undefined) {
                str = localStorage.getItem("sortOrder");
                setsortOrder(str);
              }
              const data = commentList.filter(
                (item) => item.reflection_comment_id !== commentId
              );
              setCommentList(data);
              // getComments(str, offsetComments)
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            Swal.fire({
              heightAuto: false,
              title: "Error",
              text: "Cannot delete the comment",
              icon: "error",
            });
          });
      }
    });
  };

  const addComment = (commentText, isPublic) => {
    return axios
      .post(serverUrl.ReflectionPost + "/comment", {
        reflection_id: post.id,
        comment: commentText,
        visibility: isPublic,
      })
      .then((resp) => {
        if (resp.status === 200) {
          let str = sortOrder;
          if (localStorage.getItem("sortOrder") != undefined) {
            str = localStorage.getItem("sortOrder");
            setsortOrder(str);
          }
          post.comments = post.comments + 1;
          let object = [
            {
              photo: userProfile?.photo,
              fullname: userProfile?.fullname,
              created_on: new Date(),
              guid: userProfile?.guid,
              reflection_comment_id: resp.data?.reflection_comment_id,
              user_id: resp.data?.user_id,
              comments: commentText,
              visibility: isPublic,
            },
          ];
          if (toggleComment == false) {
            setCommentList([]);
            setOffsetComments(0);
            setToggleComment(true);
            getComments(offsetComments);
          } else {
            if (str == "desc") {
              if (hasMoreComments == false || sortOrderInitial == "desc") {
                setCommentList([...object, ...commentList]);
              }
            }
            if (str == "asc") {
              if (hasMoreComments == false || sortOrderInitial == "desc") {
                setCommentList([...commentList, ...object]);
              }
            }
          }
          setComment("");
          // getComments(str, offsetComments)
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const handleRemovePost = (showcasePostId) => {
    handleClose();
    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure you want to remove this post?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteShowcasePost(showcasePostId))
          .then(() => {
            dispatch(getShowcases());
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Post has been removed",
              icon: "success",
            });
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            Swal.fire({
              heightAuto: false,
              title: "Error",
              text: "Cannot remove the post",
              icon: "error",
            });
          });
      }
    });
  };

  const handleSort = (str) => {
    setsortOrder(str);
    localStorage.setItem("sortOrder", str);
    if (str == "asc") {
      const ascSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
      setCommentList(ascSortedData);
    }
    if (str == "desc") {
      const descSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
      setCommentList(descSortedData);
    }
    // getComments(str, offsetComments)
  };

  const loadMoreComments = () => {
    setLoadingComments(true);
    let count = offsetComments + 10;
    setOffsetComments(offsetComments + 10);
    getComments(count);
  };
  const [isPublic, setIsPublic] = useState(true);
  const handlePrivatePublic = (data) => {
    if (isPublic != data) {
      setIsPublic(!isPublic);
    }
  };

  const handleNavigate = () => {
    history.push(`/journal/edit/${post.id}`, {
      src: "/",
      tabId,
      showCase: true,
    });
  };
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [likeList, setlikeList] = useState([]);

  const showMembers = () => {
    setIsLoading(true);
    setShow(true);
    axios
      .get(serverUrl.GetLikesMembers + `/${post.id}`)
      .then((res) => {
        let list = res.data.results;
        setlikeList(list);
        setIsLoading(false);
        setShow(true);
      })
      .catch((err) => {
        setIsLoading(false);
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const Members = () => {
    let style = show ? "flex" : "hidden";
    style +=
      " fixed inset-0 modelIndex items-center justify-center bg-black bg-opacity-50 px-4 py-6";
    return (
      <div className={style}>
        <div
          className={`relative cardBackgroundColor rounded-xl shadow-md p-4 max-w-full max-h-screen overflow-auto top-2 bottom-2 right-2 left-2 modal-popup-width`}
        >
          <div className="flex gap-2 items-center justify-between">
            <p className="font-semibold blackColor">Likes</p>
            <button
              onClick={() => {
                setShow(false);
                setlikeList([]);
              }}
              className="text-gray-600 hover:text-black text-xl font-bold"
            >
              &times;
            </button>
          </div>
          <div>
            {isLoading ? (
              <div className="w-full flex items-center justify-center">
                <CommonLoader />
              </div>
            ) : (
              // `${isPinned ? "overflow-y-auto max-h-72" : "overflow-y-auto h-4/6 pb-2"}
              <div className={`overflow-y-aut0 max-h-72`}>
                {likeList &&
                  likeList.map((likeItem, index) => (
                    <div key={index} className="flex my-3 gap-2 items-center">
                      <Link to={"/profile/" + likeItem.guid} target="_blank">
                        <img
                          src={likeItem.photo ? likeItem.photo : noprofile}
                          className="rounded-full w-9 h-9"
                        />
                      </Link>
                      <Link
                        to={"/profile/" + likeItem.guid}
                        target="_blank"
                        className="font-semibold blackColor text-base hover:opacity-80 hover:no-underline"
                      >
                        <p className="blackColor">{likeItem.fullname}</p>
                      </Link>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {post?.likes?.count > 0 && show && <Members />}
      <div className="gap-4 pb-4">
        <CardNew
          className={
            "flex bg-white relative overflow-hidden border flex-col cursor-pointer md:flex-row " +
            (toggleComment ? "rounded-t-xl" : "rounded-t-xl")
          }
          onClick={() => {
            if (!open) {
              history.push(
                `/post/${post.id}`,
                { src: location.pathname },
                { state: { tabId } }
              );
            }
          }}
        >
          {/* <img
                    className="h-max w-1/3 object-cover cursor-pointer"
                    src={(post.cover && (post.cover.length > 0)) ? post.cover : NO_IMAGE}
                    alt={post.title}
                    onError={(e) => { e.target.src = NO_IMAGE }}
                /> */}
          <div className="md:w-80 md:h-80 flex-shrink-0">
            <img
              src={post.cover && post.cover.length > 0 ? post.cover : NO_IMAGE} // Replace with your actual image URL
              alt={post.title}
              className="w-full h-80 object-cover max-h-64 md:max-h-full p-4 border30px"
              onError={(e) => {
                e.target.src = NO_IMAGE;
              }}
            />
          </div>
          {/* <div className="flex flex-1 flex-col pr-3 pl-4 xl:pl-10 lg:pr-0 pt-5 md:pt-4 lg:pt-5 xl:pt-6 cursor-pointer">
                    <div className="flex flex-row pt-3 items-center ">
                        <img className="h-9 w-9 lg:h-12 lg:w-12 mr-2 xl:mr-7 rounded-full"
                            src={getProfilePic(profile.photo)} alt={profile.name}
                        />
                        <div className="flex flex-col lg:mr-10 text-left cursor-pointer"
                        >
                            <p className="block lg:hidden text-sm lg:text-lg font-semibold">{trimString(post.title, 25)}</p>
                            <p className="hidden lg:block text-sm lg:text-lg font-semibold">{trimString(post.title, 30)}</p>
                        </div>
                        <div className="flex flex-row items-center absolute top-3 lg:top-4 xl:top-5 right-0">
                            <TextGray className="text-sm lg:text-base font-normal">
                                {moment.utc(post.created).local().startOf('seconds').fromNow()} ({convertDate(post.created)})
                            </TextGray>
                            <div ref={popupRef} className="cursor-pointer justify-center flex items-center w-10 lg:mr-4" onClick={(e) => toggleDropdown(e)}>
                                {isView == false ? "" :
                                    <img
                                        className="opacity-80 hover:opacity-100"
                                        src={MORE_GRAY}
                                        alt="icon"
                                    ></img>}
                                {dropdown && (
                                    <MenuItemCard
                                        className="absolute -top-6 right-6 bg-white w-24 lg:w-48 mt-3.5 p-3 rounded-md filter drop-shadow transform z-10 translate-y-10"
                                    >
                                        <li className="md:pb-2 pl-2">
                                            <MenuItemDiv
                                                className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer text-black"
                                                onClick={() => history.push(
                                                    `/journal/edit/${post.id}`,
                                                    { src: "/", tabId, showCase: true }
                                                )}
                                            >
                                                <p className="text-sm ">Edit post</p>
                                            </MenuItemDiv>

                                        </li>
                                        <li className="md:pb-2 pl-2">
                                            <MenuItemDiv
                                                className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer text-black"
                                                onClick={() => handleRemovePost(post.sc_id)}
                                            >
                                                <p className="text-sm ">Remove from showcase</p>
                                            </MenuItemDiv>

                                        </li>
                                    </MenuItemCard>
                                )}

                            </div>


                        </div>
                    </div>
                    <div className="flex-1 flex flex-col">
                        <hr className="my-3 w-full" />
                        <div className="h-24 lg:h-32 flex flex-col overflow-hidden">
                            <div className="text-viewer flex-1 text-sm lg:text-base break-words font-normal mb-3 container-multi overflow-wrap-break-word"
                            >
                                <div className="multiline-ellipsis6" dangerouslySetInnerHTML={{ __html: removeIframe(post.content) }} />
                            </div>
                        </div>

                        <Link
                            className="mt-2 mr-4 flex justify-end mb-2 xl:mb-0 
                            opacity-60 hover:opacity-80 hover:no-underline cursor-pointer"
                            to={{
                                pathname: '/post/' + post.id,
                                src: location.pathname,
                                state: { tabId },
                            }}
                        >
                            <TextGray>Read more</TextGray>

                        </Link>

                        <div className="flex gap-2 xl:mb-3 flex-wrap overflow-y-scroll">
                            {/* hashtags, events, groups, courses must be a list 
                            {/* {   
                                post.hashtag &&
                                post.hashtag.map((hashtag, index) => (
                                    <ButtonHashtag key={index} text={hashtag} color="blue" />
                                ))
                            }
                            {   
                                post.values &&
                                post.values.map((value, index) => (
                                    <ButtonHashtag key={index} text={value.value} color="orange" />
                                ))
                            }
                            {   
                                post.events &&
                                post.events.map((events, index) => (
                                    <ButtonHashtag key={index} text={events.value} color="orange" />
                                ))
                            }
                            {   
                                post.courses &&
                                post.courses.map((course, index) => (
                                    <ButtonHashtag key={index} text={course.value} color="red" />
                                ))
                            }
                            {   
                                post.groups &&
                                post.groups.map((group, index) => (
                                    <ButtonHashtag key={index} text={group.value} color="blue" />
                                ))
                            } 
                        </div>
                    </div>
                    <div className="flex flex-col lg:flex-row align-center md:mt-3 space-y-3 xl:space-y-0" onClick={(e) => e.stopPropagation()}>
                        {
                            (post.likes.avatars.length > 0) && <AvatarGroup likesList={post.likes.avatars} />
                        }
                        <LikeComment
                            currentIsLiked={currentIsLiked}
                            numLikes={post.likes.count}
                            numComments={post.comments}
                            isPinned={true}
                            reflection_id={post.id}
                            isShowcase={true}
                            handleComment={handleCommentClick}
                            handleLike={() => likePost(currentIsLiked === 1 ? 0 : 1)}
                        />
                    </div>
                    <div className="mt-3">
                        <CommentInput
                            comment={comment}
                            setComment={setComment}
                            commentPost={addComment}
                            profilePhoto={profile.photo}
                        />
                    </div>
                </div> */}
          {/* Content Section */}
          <div className="p-4 md:pl-0 md:flex-grow flex flex-col justify-between">
            <div>
              <div className="flex flex-col sm:flex-row justify-between mb-2">
                <h3 className="text-lg font-bold blackColor mb-1 sm:mb-0">
                  {trimString(post?.title, 25)}
                </h3>
                <span className="lightColor text-sm flex items-center">
                  {moment
                    .utc(post.updated)
                    .local()
                    .startOf("seconds")
                    .fromNow()}{" "}
                  ({convertDateFormat(post.updated)})
                  <div className="cursor-pointer">
                    {/* <IconButton > */}
                    <MoreVertIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick(e);
                      }}
                      className="cursor-pointer"
                    />
                    {/* </IconButton> */}
                    <MenuItemCard>
                      <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        classes={{ paper: classes.customMenu }}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        disableScrollLock={true}
                      >
                        <MenuItemCard>
                          <MenuItem
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNavigate();
                            }}
                            className="DropDownFont"
                          >
                            <MenuItemDiv className="blackColor  text-sm">
                              Edit post
                            </MenuItemDiv>
                          </MenuItem>
                          <MenuItem
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemovePost(post.sc_id);
                            }}
                            className="DropDownFont"
                          >
                            <MenuItemDiv className="blackColor  text-sm">
                              Remove from showcase
                            </MenuItemDiv>
                          </MenuItem>
                        </MenuItemCard>
                      </Menu>
                    </MenuItemCard>
                  </div>
                </span>
              </div>
              <p className=" text-base leading-relaxed mb-4">
                <div className="text-viewer flex-1 text-sm lg:text-base break-words font-normal mb-3 container-multi overflow-wrap-break-word">
                  <RichTextReadMore
                    htmlContent={removeIframe(post?.content)}
                    maxLines={4}
                    postId={post?.id}
                    src={location.pathname}
                    state={tabId}
                  />
                  {/* <div className="multiline-ellipsis5" dangerouslySetInnerHTML={{ __html: removeIframe(post.content) }} /> */}
                </div>
              </p>
              {/* <div className="flex w-full">
                            <Link
                                className="mt-2 flex justify-end mb-2 xl:mb-0 
                            opacity-60 hover:opacity-80 hover:no-underline cursor-pointer"
                                to={{
                                    pathname: '/post/' + post.id,
                                    src: location.pathname,
                                    state: { tabId },
                                }}
                            >
                                <a href="#" className="blueColor text-sm">
                                    Read More ...
                                </a>
                            </Link>
                        </div> */}
            </div>
            <div className="mt-4 md:mt-6" onClick={(e) => e.stopPropagation()}>
              {/* <div className={`relative w-full flex items-center`}>
                            <input
                                value={comment}
                                placeholder="Type your comment here"
                                rows="3"
                                className="flex-grow bg-transparent text-gray-700 textArea placeholder-gray-400 text-sm resize-none p-2 pr-7 border-2 rounded-lg"
                                onChange={(e) => setComment(e.target.value)}
                            // style={{
                            //     overflow: "auto",
                            //     resize: "none",
                            //     maxHeight: "200px",
                            //     minHeight: "75px"
                            // }}
                            />
                            <div className="absolute right-2 bottom-2 flex gap-2 items-center">
                                {isPublic == true ?
                                    <Tooltip title={"Click to switch to private comment"} placement="top" arrow>
                                        <span className='z-50 -ml-7'>
                                            <MdOutlinePublic className='w-6 h-6 z-50 cursor-pointer primaryIcon' onClick={() => handlePrivatePublic(false)} />
                                        </span>
                                    </Tooltip> :
                                    <Tooltip title={"Click to switch to public comment"} placement="top" arrow>
                                        <span className='z-50 -ml-7'>
                                            <IoMdLock className='w-6 h-6 z-50 cursor-pointer secondaryIcon' onClick={() => handlePrivatePublic(true)} />
                                        </span>
                                    </Tooltip>}
                                <div className="CameraIcon rounded-full p-2 shadow-md cursor-pointer hover:bg-gray-100" onClick={() => addComment(comment, isPublic)}>
                                    <LuSend fontSize="text-md" className="text-white " />
                                </div>
                            </div>
                        </div> */}
              <ChatInput
                message={comment}
                setMessage={setComment}
                addComment={addComment}
                isPublic={isPublic}
                handlePrivatePublic={handlePrivatePublic}
              />

              {/* Likes and Comments Count */}
              <div className="flex items-center mt-2 px-2 lightColor text-sm">
                <div className="flex items-center mr-3 gap-0.5 cursor-pointer">
                  {currentIsLiked ? (
                    <ThumbUpAltIcon
                      onClick={() => likePost(currentIsLiked === 1 ? 0 : 1)}
                      fontSize="small"
                      className={`likeIcon primaryIcon`}
                    />
                  ) : (
                    <ThumbUpOffAltIcon
                      onClick={() => likePost(currentIsLiked === 1 ? 0 : 1)}
                      fontSize="small"
                      className={`likeIcon secondaryIcon`}
                    />
                  )}
                  <span
                    onClick={() => {
                      if (post?.likes?.count>0) {
                        showMembers();
                      }
                      else{
                        likePost(currentIsLiked === 1 ? 0 : 1);
                      }
                    }}
                    className="lightColor"
                  >
                    {post?.likes?.count} Likes
                  </span>
                </div>
                <div
                  className="flex items-center gap-0.5 cursor-pointer"
                  onClick={handleCommentClick}
                >
                  <FaRegCommentDots className={`w-4 h-4 secondaryIcon`} />
                  {/* <SmsOutlinedIcon fontSize="small" className="likeIcon" /> */}
                  <span className="lightColor">{post?.comments} Comments</span>
                </div>
              </div>
            </div>
          </div>
        </CardNew>
        <div
          className={
            "block py-2 rounded-b-xl border-b border-r border-l backgroundColor8 blackColor"
          }
          // className={toggleComment === true ? "block pt-1 rounded-b-xl py-5" : "hidden"}
          // style={{'backgroundColor': '#F9F9F9'}}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={`px-5`}>
            {post?.comments != 0 && (
              <>
                <div className="flex flex-col sm:flex-row items-center justify-between">
                  <p className="text-base font-semibold blackColor">
                    Comments ({post?.comments})
                  </p>
                  {toggleComment == true && (
                    <>
                      <SortToggle onChange={handleSort} sortOrder={sortOrder} />
                      {/* <div className='flex gap-3 cursor-pointer' onClick={() => { handleSort(sortOrder == "asc" ? "desc" : "asc") }}>
                                    {sortOrder == "asc" ?
                                        <>
                                            <BsSortUp className='w-6 h-6 primaryIcon' />
                                        </> :
                                        <>
                                            <BsSortDownAlt className='w-6 h-6 primaryIcon' />
                                        </>
                                    } *
                                </div>*/}
                    </>
                  )}
                  {/* <img src={SortingIcon} className='w-6 h-6 cursor-pointer' style={{ transform: sortOrder == "asc" ? 'rotate(180deg)' : 'rotate(0deg)' }}
                                    onClick={() => { handleSort(sortOrder == "asc" ? "desc" : "asc") }} /></>} */}
                </div>
              </>
            )}
            {toggleComment === false && (
              <>
                {post?.latest_comment ? (
                  <Comment
                    // key={index}
                    // order={index}
                    profilePic={post?.latest_comment?.photo}
                    username={post?.latest_comment?.fullname}
                    createdOn={post?.latest_comment?.created_on}
                    comment={post?.latest_comment?.comment}
                    // handleDelete={() => deleteComment(post?.latest_comment?.reflection_comment_id)}
                    deleteView={true}
                    // userId={post?.latest_comment?.user_id}
                    isView={isView}
                    guID={post?.latest_comment?.user_guid}
                    isPrivate={post?.latest_comment?.visibility}
                  />
                ) : (
                  <p className="py-1">There is no comment yet.</p>
                )}{" "}
              </>
            )}
            {toggleComment === true && (
              <>
                {commentList.length > 0
                  ? commentList.map((comment, index) => (
                      <Comment
                        key={index}
                        order={index}
                        profilePic={comment.photo}
                        username={comment.fullname}
                        createdOn={comment.created_on}
                        comment={comment.comments}
                        handleDelete={() =>
                          deleteComment(comment.reflection_comment_id)
                        }
                        userId={comment.user_id}
                        isView={isView}
                        guID={comment.guid}
                        isPrivate={comment.visibility}
                      />
                    ))
                  : loadingComments === false && (
                      <p className="py-1">There is no comment yet.</p>
                    )}
              </>
            )}
          </div>
          {loadingComments && (
            <div className="grid grid-cols-1 h-10">
              <div className="justify-center justify-self-center mt-1.5">
                <Loading active={loadingComments} />
              </div>
            </div>
          )}
          {toggleComment && hasMoreComments && (
            <div className="grid grid-cols-1 h-14 mt-3">
              <div className="justify-center justify-self-center">
                <ButtonCommonTopNew
                  className="px-5 border p-2 text-sm rounded-lg cursor-pointer"
                  onClick={loadMoreComments}
                >
                  Load More
                </ButtonCommonTopNew>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

CardPost.propTypes = {
  post: PropTypes.object,
  profile: PropTypes.object,
};

export default CardPost;
